var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { connect } from 'react-redux';
import { EMPTY_TEXT } from '@mitchell/react.component.ux';
import { getQuestionnaireEvaluationQuestionAttributeType } from "../../questionnaireEvaluation";
import { EnterpriseDocStoreService } from "../../common";
import { photoCaptureIntelligentImageDetailsRequestAction, photoCaptureIntelligentResetImageAnalyzerDetailsAction, photoCaptureIntelligentUpdateOCRInfo, photoCaptureIntelligentViewChangeAction } from '../actions';
import { IntelligentPhotoCaptureViewType } from '../enums';
import { IntelligentPhotoCapturePhotoPreview } from '../components';
import { getIntelligentSequenceScreenName, getIntelligentIsPhotoCapureLoading, getPhotoCaptureFileSizeLimit, getPhotoCaptureCompanyCode, getShouldAllowMitchellIntelligent, getShouldEnableOCRImageTextDecode, getIntelligentPhotoCaptureserviceFailStatus, getShouldEnableImageQualityAssessment, getPhotoCaptureCountryCode, getCapturedUploadPhotoFiles, getIntelligentPhotoOCRInfo, getShouldEnableAdditionalOption } from '../selectors';
const mapStateToProps = (state) => ({
    questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
    sequenceScreenName: getIntelligentSequenceScreenName(state),
    isLoading: getIntelligentIsPhotoCapureLoading(state),
    fileSizeLimit: getPhotoCaptureFileSizeLimit(state),
    companyCode: getPhotoCaptureCompanyCode(state),
    shouldAllowMitchellIntelligent: getShouldAllowMitchellIntelligent(state),
    shouldEnableOCRImageTextDecode: getShouldEnableOCRImageTextDecode(state),
    serviceFailedStatus: getIntelligentPhotoCaptureserviceFailStatus(state),
    shouldEnableImageQualityAssessment: getShouldEnableImageQualityAssessment(state),
    countryCode: getPhotoCaptureCountryCode(state),
    files: getCapturedUploadPhotoFiles(state),
    ocrInfo: getIntelligentPhotoOCRInfo(state),
    shouldDisplayIQAScreen: getShouldEnableAdditionalOption(state)
});
const mapDispatchToProps = (dispatch) => ({
    onRetakePhoto: (sequenceScreenName) => {
        dispatch(photoCaptureIntelligentViewChangeAction(IntelligentPhotoCaptureViewType.CAMERA, sequenceScreenName));
    },
    onViewChange: (view, sequenceScreenName) => {
        dispatch(photoCaptureIntelligentViewChangeAction(view, sequenceScreenName));
    },
    onSaveManualInterventionData: (updatedOCR) => {
        const ocrInfo = {
            ocrText: updatedOCR,
            errorMessage: EMPTY_TEXT
        };
        dispatch(photoCaptureIntelligentUpdateOCRInfo(ocrInfo));
    },
    onLoadImageAnalysis: (imageDocUID, shouldDisplayIQAScreen) => __awaiter(void 0, void 0, void 0, function* () {
        if (!imageDocUID)
            return;
        const fileUrl = yield EnterpriseDocStoreService.getFileS3URL(imageDocUID);
        const requestPayload = {
            clientRequestUid: imageDocUID,
            referenceId: EMPTY_TEXT,
            images: [{ uid: imageDocUID, uri: fileUrl }]
        };
        dispatch(photoCaptureIntelligentResetImageAnalyzerDetailsAction(shouldDisplayIQAScreen));
        dispatch(photoCaptureIntelligentImageDetailsRequestAction(requestPayload));
    })
});
const IntelligentPhotoCapturePhotoPreviewWrapper = (props) => {
    return React.createElement(IntelligentPhotoCapturePhotoPreview, Object.assign({}, props));
};
export const ConnectedIntelligentPhotoCapturePhotoPreview = connect(mapStateToProps, mapDispatchToProps)(IntelligentPhotoCapturePhotoPreviewWrapper);
//# sourceMappingURL=ConnectedIntelligentPhotoCapturePhotoPreview.js.map